import React, { useState } from "react";
import { Button } from "Components/Button";
import { Dropdown } from "melodies-source/Dropdown";
import styled from "styled-components";
import { Placement } from "@popperjs/core";

interface MenuItem {
  label: string;
  onClick: () => void;
}

interface Props extends React.ComponentProps<typeof Button> {
  menu: { items: MenuItem[]; placement: Placement; width?: string };
}

export const DropdownButton: React.FC<Props> = ({ menu, ...props }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  function toggleMenuOpen() {
    setIsMenuOpen((open) => !open);
  }

  return (
    <div>
      <StyledButton
        {...props}
        onClick={isMenuOpen ? undefined : toggleMenuOpen}
      />
      <StyledDropdown
        placement={menu.placement}
        isOpen={isMenuOpen}
        onClose={toggleMenuOpen}
      >
        <MenuContainer style={{ width: menu.width || 220 }}>
          {menu.items.map((item) => (
            <MenuItem
              key={item.label}
              onClick={() => {
                item.onClick();
                toggleMenuOpen();
              }}
            >
              {item.label}
            </MenuItem>
          ))}
        </MenuContainer>
      </StyledDropdown>
    </div>
  );
};

const StyledButton = styled(Button)`
  padding: 0;
`;

const StyledDropdown = styled(Dropdown)`
  border-radius: 10px;
  overflow: hidden;
`;

const MenuContainer = styled.div``;

const MenuItem = styled.div`
  padding: 15px 20px;
  cursor: pointer;

  &:hover {
    background-color: var(--hover-background-color);
  }
`;
